import { sessionRecordingService } from 'src/services/sessionRecordingService';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSessionRecorder = () => {
  if (process.env.NODE_ENV === 'development') {
    return null;
  }

  return {
    identifyUser: sessionRecordingService.identifyUser,
    trackEvent: sessionRecordingService.trackEvent,
  };
};
